import header from "./hotel-am-morgen.png";
import section1 from "./hotel-mit-grundriss-2.png";
import section2 from "./ausschnitte-eines-hotelzimmers.png";
import section3 from "./kunde-klingelt-an-rezeption.png";
import section4 from "./hotel-mit-grundriss.png";
import section5 from "./hotelansichten.png";
import section6 from "./hotel-mitarbeitende.png";
import section7 from "./hotelzimmer.png";
import section8 from "./barrierefrei.png";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
};
